import React from 'react';
import { t } from 'i18next';
import { Grid } from 'react-bootstrap';

export const NotFound = ({ location }) => (
    <Grid>
        <h3>
            {t('Oops, nothing to show for for')} <code>{location.pathname}</code>
        </h3>
    </Grid>
);
